var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2467 12.7057H5.91341C3.80008 12.7057 2.08008 10.9857 2.08008 8.8724C2.08008 6.75906 3.80008 5.03906 5.91341 5.03906H13.2467C13.5201 5.03906 13.7467 5.26573 13.7467 5.53906C13.7467 5.8124 13.5201 6.03906 13.2467 6.03906H5.91341C4.35341 6.03906 3.08008 7.3124 3.08008 8.8724C3.08008 10.4324 4.35341 11.7057 5.91341 11.7057H11.2467C11.5201 11.7057 11.7467 11.9324 11.7467 12.2057C11.7467 12.4791 11.5267 12.7057 11.2467 12.7057Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7132 7.70659C11.5865 7.70659 11.4598 7.65992 11.3598 7.55992C11.1665 7.36659 11.1665 7.04659 11.3598 6.85326L12.7132 5.49992L11.3598 4.14659C11.1665 3.95326 11.1665 3.63326 11.3598 3.43992C11.5532 3.24659 11.8732 3.24659 12.0665 3.43992L13.7732 5.14659C13.9665 5.33992 13.9665 5.65992 13.7732 5.85326L12.0665 7.55992C11.9665 7.65992 11.8398 7.70659 11.7132 7.70659Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.c065c28b.svg";
export { ForwardRef as ReactComponent };